
export default {
  name: 'IllinoisIcons',
  props: {
    icon: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: false,
      default: 16
    },
    height: {
      type: Number,
      required: false,
      default: 16
    }
  }
};
